export function updatePersonalInformationProfile(data) {
  const url = SOPHIA.Routes.update_sdn_information_profile_path()
  const xhr = {
    data: data,
    dataType: 'json',
    method: 'POST',
    url: url
  }
  return SOPHIA.sendXHR(xhr)
}

export function getDiscounts() {
  const xhr = {
    dataType: 'json',
    method: 'GET',
    url: '/scholarships-discounts-network/api/mine'
  }
  return SOPHIA.ajax(xhr)
}

export function getNotifications(params) {
  const xhr = {
    dataType: 'json',
    method: 'GET',
    url: '/notifications',
    data: params,
  };
  return SOPHIA.ajax(xhr);
}

export function setNotificationRead(id) {
  const xhr = {
    dataType: 'json',
    method: 'GET',
    url: '/notifications/' + id,
  };
  return SOPHIA.ajax(xhr);
}
